import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-leads-status',
  templateUrl: './leads-status.component.html',
  styleUrls: ['./leads-status.component.css']
})
export class LeadsStatusComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
